<template>

    <div class="row" style="position: relative;padding-left: 10px;">
        <AppNav :data="{app_key: 'plan',app_name: '计划',page_name: '编辑计划'}" class="col-md-12 pr-0"></AppNav>
        <div v-if="isOwner" class="col-md-12 pr-0">
            <div class="top-bar">
                <div style="margin-left: 78px;">
                    <span class=""></span>
                    <el-select v-model="planType" disabled placeholder="请选择计划类型">
                        <el-option
                                v-for="item in plan_type_options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                    <div v-if="planType == 'quarter'" id="quarter-plan" style="margin-left: 15px;">
                        <QuarterPicker :defaultValue="dateValue" :editable="false" @fuc="getDate"></QuarterPicker>
                    </div>
                    <div v-if="planType == 'month'" id="month-plan" style="margin-left: 15px;">
                        <el-date-picker v-model="dateValue"
                                        :editable="false"
                                        disabled
                                        placeholder="选择月"
                                        type="month">
                        </el-date-picker>
                    </div>
                    <div v-if="planType == 'week'" id="week-plan" style="margin-left: 15px;">
                        <WeekPicker :editable="false" :endDate="endDate" :startDate="startDate" :weekValue="dateValue"
                                    @fuc="getDate"
                        ></WeekPicker>
                    </div>
                    <div v-if="planType == 'custom'" id="custom-plan" class="new-custom-plan" style="display:inline;">
                        <el-date-picker
                                v-model="dateValue"
                                end-placeholder="结束日期"
                                range-separator="至"
                                start-placeholder="开始日期"
                                type="daterange">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="new-main" style="min-height: 410px;margin-bottom: 20px">
                <div class="table-wrap">
                    <table>
                        <tbody>
                        <tr>
                            <td class="odd"><em class="must-fill">*&nbsp;</em></td>
                            <td class="even relative">
                                <input id="planTitle" v-model="title" class="plan-title" maxlength="45"
                                       placeholder="计划标题"
                                       type="text" value="">
                                <span class="other-plan">
                        <a v-if="planType == 'week'" class="look-prev" href="javascript:void(0)"
                           @click="showPreviewPlan">
                                    回顾上一周
                        </a>
                                          <a v-if="planType == 'month'" class="look-prev"
                                             href="javascript:void(0)" @click="showPreviewPlan">
                                    回顾上一月
                        </a>
                                          <a v-if="planType == 'quarter'" class="look-prev"
                                             href="javascript:void(0)" @click="showPreviewPlan">
                                    回顾上一季度
                        </a>
                    </span>

                            </td>
                        </tr>
                        <tr>
                            <td class="v-top"><span class="mar-top16"></span></td>
                            <td id="category" class="even ui-sortable ui-sortable-disabled">
                                <div class="plan-content-wrap">
                                    <div class="plan-content">
                                        <div class="content-title"
                                             style="overflow: hidden;">
                                            <textarea
                                                    v-model="content"
                                                    placeholder="主要工作内容"
                                                    style="height: 60px;width:600px;float: left;padding: 5px;border-radius: 6px;"></textarea>
                                        </div>
                                        <div style="clear: both;"></div>
                                        <div class="add-detail" style="clear: both">
                                            <span class="text-blue" @click="addRuleData()">+添加细则</span><span
                                                class="text-gray">计划分类下可添加一条或多条计划细则，每条细分都可单独处理</span>
                                        </div>
                                        <div class="plan-detail-box ui-sortable ui-sortable-disabled">
                                            <div class="plan-detail-wrap">
                                                <div v-for='(item,index) in lists' :key="index"
                                                     class="plan-detail"
                                                     style="margin-left: 20px;position: relative">
                                                        <textarea
                                                                v-model="item.content" class="planDetail rule-index"
                                                                data-value="item.content"
                                                                placeholder="计划细则"
                                                                style="height: 30px;width:420px;float: left;padding: 5px;border-radius: 6px;min-height: 30px;"></textarea>
                                                    <div class="" style="float: left;margin-left: 10px;">
                                                        <el-date-picker v-model="item.rDate"
                                                                        :picker-options="limitDateStart(item)"
                                                                        class="detailDate"
                                                                        placeholder="开始日期" style="width: 110px;"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd">
                                                        </el-date-picker>
                                                        <span style="margin: 0 10px 0 3px">至</span>
                                                        <el-date-picker v-model="item.eDate"
                                                                        :editable="false"
                                                                        :picker-options="limitDateEnd(item)"
                                                                        class="detailDate"
                                                                        placeholder="截止日期" style="width: 110px;"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd">
                                                        </el-date-picker>

                                                        <input v-model="item.isImportant"
                                                               style="margin-left: 2px;padding-top: 2px"
                                                               type="checkbox"/>
                                                        <span style="margin-left: 8px">重要</span>
                                                    </div>
                                                    <i v-if="item.plan_id === plan_id"
                                                       class="icon-remove remove sec-remove" title="删除该计划细则"
                                                       v-on:click='change_del_state(index)'></i>
                                                    <el-popover v-else
                                                                content="该细则不属于本计划"
                                                                placement="top"
                                                                trigger="hover"
                                                                width="100">
                                                        <i slot="reference" class="el-icon-info"
                                                           style="position:relative;top: 6px;left: 10px;font-size: 16px;"></i>
                                                    </el-popover>
                                                </div>
                                            </div>
                                            <div v-if="otherList.length > 0" class="plan-detail-wrap"
                                                 style="margin-top: 5px;">
                                                <p style="margin-left: 20px;color: #2299ee;"><i class="fa fa-tasks"></i>
                                                    其他细则 <span style="font-weight: bold;">{{ otherList.length }}</span>
                                                </p>
                                                <div v-for='(item,index) in otherList' :key="index"
                                                     class="plan-detail"
                                                     style="margin-left: 20px;position: relative">
                                                        <textarea
                                                                v-model="item.content" class="planDetail rule-index"
                                                                data-value="item.content"
                                                                placeholder="计划细则"
                                                                style="height: 30px;width:420px;float: left;padding: 5px;border-radius: 6px;min-height: 30px;"></textarea>
                                                    <div class="" style="float: left;margin-left: 10px;">
                                                        <el-date-picker v-model="item.rDate"
                                                                        :picker-options="limitDateStart(item)"
                                                                        class="detailDate"
                                                                        placeholder="开始日期" style="width: 110px;"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd">
                                                        </el-date-picker>
                                                        <span style="margin: 0 10px 0 3px">至</span>
                                                        <el-date-picker v-model="item.eDate"
                                                                        :editable="false"
                                                                        :picker-options="limitDateEnd(item)"
                                                                        class="detailDate"
                                                                        placeholder="截止日期" style="width: 110px;"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd">
                                                        </el-date-picker>

                                                        <input v-model="item.isImportant"
                                                               style="margin-left: 2px;padding-top: 2px"
                                                               type="checkbox"/>
                                                        <span style="margin-left: 8px">重要</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="add-category" style="display: none;"><i class="icon-add-category"></i><span>+继续添加计划内容</span>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="recycleList.length > 0">
                            <td class="v-top"><span class="mar-top16"></span></td>
                            <td id="category1" class="even ui-sortable ui-sortable-disabled">
                                <div class="plan-content-wrap">
                                    <div class="plan-content">
                                        <p class="recovery-tip"
                                           style="font-size: 12px;font-weight: bold;margin-bottom: 5px;"><i
                                                class="fa fa-trash"></i> 已删细则</p>
                                        <div class="plan-detail-box ui-sortable ui-sortable-disabled">
                                            <div class="plan-detail-wrap">
                                                <div v-for='(item,index) in recycleList' :key="index"
                                                     class="plan-detail"
                                                     style="margin-left: 20px;position: relative">
                                                        <textarea
                                                                v-model="item.content"
                                                                :disabled="true" class="planDetail rule-index"
                                                                data-value="item.content"
                                                                placeholder="计划细则"
                                                                style="height: 30px;width:420px;float: left;padding: 5px;border-radius: 6px;min-height: 30px;"></textarea>
                                                    <div class="" style="float: left;margin-left: 10px;">
                                                        <el-date-picker v-model="item.rDate"
                                                                        :disabled="true"
                                                                        :editable="false"
                                                                        :picker-options="limitDateStart(item)"
                                                                        class="detailDate"
                                                                        placeholder="开始日期" style="width: 110px;"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd">
                                                        </el-date-picker>
                                                        <span style="margin: 0 10px 0 3px">至</span>
                                                        <el-date-picker v-model="item.eDate"
                                                                        :disabled="true"
                                                                        :editable="false"
                                                                        :picker-options="limitDateEnd(item)"
                                                                        class="detailDate"
                                                                        placeholder="截止日期" style="width: 110px;"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd">
                                                        </el-date-picker>

                                                        <input v-model="item.isImportant" :disabled="true"
                                                               style="margin-left: 2px;padding-top: 2px"
                                                               type="checkbox"/>
                                                        <span style="margin-left: 8px">重要</span>
                                                    </div>
                                                    <i class="fa-recovery fa fa-undo" title="恢复该计划细则"
                                                       v-on:click='recovery_del_state(index)'></i>
                                                    <i class="icon-delete delete true-remove" title="删除该计划细则"
                                                       v-on:click='del_true_dateail(index)'></i>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td class="even">
                                <div class="btn-group">
                                    <button class="release" @click="modify()">立即保存</button>

                                    <router-link
                                            :to="{ name: 'planinfo' , params: { id:plan_id} }">
                                        取消
                                    </router-link>

                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="showRight" class="previewBox">
            <RightPlanView :dateValue="dateValue" :plan_Type="planType" @close="clickClose()"></RightPlanView>
        </div>
    </div>
</template>

<script>
import AppNav from '@/components/common_components/nav_bar/app_nav_title.vue'
import QuarterPicker from '@/components/common_components/datepicker/quarter_picker.vue'
import WeekPicker from '@/components/common_components/datepicker/week_picker.vue'
import RightPlanView from '@/apps/plan/sub_components/right_plan_view.vue'
import planApi from '@/api/plan/plan_api.js'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
    name: "edit_plan",
    data: function () {
        return {
            showRight: false,
            quarterArray: ["01", "04", "07", "10"],
            quarterArray2: [1, 4, 7, 10],
            title: '',
            content: '',
            summary: '',
            planType: '',
            layout: 'month',
            dateValue: this.$route.params.dateValue,
            startDate: this.$route.params.startDate,
            endDate: this.$route.params.endDate,
            value1: '',
            plan_id: 0,
            weekIdex: 0,
            lists: [{
                id: 1,
                plan_id: true,
                content: '',
                rDate: '',
                eDate: '',
                isImportant: false,
                isEmergency: false,
                isDelete: false
            }],
            recycleList: [],
            deleteList: [],
            otherList: [],
            nextTodoId: 2,
            isOwner: true,
            pickerOptionsEnd: this.limitDateEnd(),
            pickerOptionsStart: this.limitDateStart(),
            plan_type_options: [{
                value: 'week',
                label: '周计划'
            }, {
                value: 'month',
                label: '月计划'
            }, {
                value: 'quarter',
                label: '季度计划'
            }, {
                value: 'custom',
                label: '自定义计划'
            }],
        }
    },
    computed: {
        ...mapState({
            plan_info: state => state.plan.plan_information,
            login_user_id: state => state.loginState.user_info.id,
            // active_plan_id: state => state.plan.active_plan_id,
        }),
        ...mapGetters({}),
    },

    methods: {
        ...mapActions({
            get_plan_info: 'plan/get_plan_info',
            change_warning_message: 'warningBar/change_message',
            change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
        }),
        getDate: function (val, val2) {
            this.dateValue = val;
            this.startDate = val;
            this.endDate = val2;
        },
        getValue: function () {
            this.layout = this.planType
        },
        autoSelectDate: function () {
            let tempStartDate = '';
            let tempEndDate = '';
            if (this.planType == 'week' || this.planType == 'custom') {
                tempStartDate = this.startDate;
                tempEndDate = this.endDate;
            } else if (this.planType == 'month') {
                const currDate = new Date(this.startDate);
                const year = currDate.getFullYear();
                const month = currDate.getMonth() + 1;
                tempStartDate = year + '-' + month + '-1';
                tempEndDate = year + '-' + month + '-' + new Date(year, month, 0).getDate();
            } else if (this.planType == 'quarter') {
                const eDateArray = this.dateValue.replace(/\//g, '-').split('-');
                const month = parseInt(eDateArray[1]) + 2;
                tempStartDate = eDateArray[0] + '-' + eDateArray[1] + '-1';
                tempEndDate = eDateArray[0] + '-' + month + '-' + new Date(eDateArray[0], month, 0).getDate();
            }
            if (tempStartDate && tempStartDate != 'undefined') tempStartDate = tempStartDate.replace(/\//g, '-');
            if (tempEndDate && tempEndDate != 'undefined') tempEndDate = tempEndDate.replace(/\//g, '-');
            else tempEndDate = '';
            return [tempStartDate, tempEndDate];
        },
        addRule: function (date) {
            this.lists.push({
                idx: this.nextTodoId++,
                id: 0,
                plan_id: true,
                content: '',
                rDate: date[0].toString().replace(/\//g, '-'),
                eDate: date[1].toString().replace(/\//g, '-'),
                isImportant: false,
                isEmergency: false,
                isDelete: false,
            })
        },
        addRuleData: function () {
            const autoDate = this.autoSelectDate();
            this.addRule(autoDate);
        },
        addDays: function (d, planType) {
            let date = new Date(d);
            let endDate = planType == 'month' ? (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (new Date(date.getFullYear(), date.getMonth() + 1, 0)).getDate()) : date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate() + 5);
            return endDate;
        },
        showPreviewPlan() {
            this.showRight = true;
            return;
        },
        clickClose() {
            this.showRight = false;
        },
        limitDateStart: function (detail) {
            let other_date = this.endDate;
            if (detail != null) other_date = detail.eDate;
            return {
                disabledDate(time) {
                    return time.getTime() > new Date(other_date).getTime();
                }
            }
        },
        limitDateEnd: function (detail) {
            let other_date = this.startDate;
            if (detail != null) other_date = detail.rDate
            return {
                disabledDate(time) {
                    return time.getTime() < new Date(other_date).getTime();
                }
            }
        },
        change_del_state(index) {
            let currData = this.lists[index];
            this.lists.splice(index, 1);
            currData.isDelete = true;
            this.recycleList.push(currData);
        },
        recovery_del_state(index) {
            let currData = this.recycleList[index];
            this.recycleList.splice(index, 1);
            currData.isDelete = false;
            this.lists.push(currData);
        },
        del_true_dateail(index) {
            let currData = this.recycleList[index];
            this.recycleList.splice(index, 1);
            currData.isDelete = "del_true";
            this.deleteList.push(currData);
        },
        modify: async function () {
            let saveMsg = ''
            let result = 'success'
            if (!this.title.trim()) {
                saveMsg = '标题不能为空'
                result = 'error'
            } else {
                if (this.planType == 'month') {
                    let arr = this.dateValue.split("-");
                    this.startDate = arr[0] + '-' + arr[1] + '-01';
                    this.endDate = this.addDays(this.startDate, 'month');
                } else if (this.planType == 'week') {

                } else if (this.planType == 'custom') {
                    this.startDate = this.dateValue[0];
                    this.endDate = this.dateValue[1];
                }
                this.startDate = this.startDate.replace('/', '-').replace('/', '-')
                this.endDate = this.endDate.replace('/', '-').replace('/', '-')
                let detailList = []
                for (let i = 0; i < this.lists.length; i++) {
                    if (this.lists[i].content.trim()) {
                        this.lists[i].rDate = this.startDate
                        detailList.push(this.lists[i])
                    }
                }
                for (let i = 0; i < this.recycleList.length; i++) {
                    if (this.recycleList[i].content.trim()) {
                        this.recycleList[i].rDate = this.startDate
                        detailList.push(this.recycleList[i])
                    }
                }


                let res = await planApi.modify_plan({
                    plan_id: this.plan_id,
                    title: this.title,
                    content: this.content,
                    planType: this.planType,
                    openTime: this.startDate,
                    endTime: this.endDate,
                    lists: detailList,
                    deleteList: this.deleteList,
                })
                let data = JSON.parse(res.data.result);
                result = data.code
                saveMsg = data.message
            }
            this.change_warning_message(saveMsg);
            if (result === 'success') {
                this.change_warning_bar_style_class('success');
                await this.$router.push({name: 'planinfo', params: {id: this.plan_id.toString()}});
            } else {
                this.change_warning_bar_style_class('alert');
            }
        },
        getWeek: function (z) {
            let day11 = new Date(z);
            day11.setMonth(0);
            day11.setDate(1);
            day11.setHours(0);
            day11.setMinutes(0);
            day11.setSeconds(0);//到这里就得到该年的一月一日
            let day11mill = day11.getTime();
            let ori_day = day11.getDay();//该年的一月一日是星期几
            let fill1 = 0;//与星期日相隔的毫秒数
            if (ori_day !== 0) {
                fill1 = ori_day * 60 * 60 * 24 * 1000;
            }

            let now = Date.parse(z);
            now = new Date(now);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            let nowmill = now.getTime();
            let now_day = now.getDay();
            let fill2 = 0;
            if (now_day !== 0) {
                fill2 = (7 - now_day) * 60 * 60 * 24 * 1000;
            }

            let cha2 = (nowmill - day11mill + fill1 + fill2) / (60 * 60 * 24 * 1000);
            let week = Math.ceil(cha2 / 7);
            if (week < 10) {
                week = "0" + week;
            }
            return week;
        }
    },
    components: {
        AppNav,
        QuarterPicker,
        WeekPicker,
        RightPlanView
    },
    async mounted() {
        let planId = this.$route.params.id;
        if (typeof (planId) != "undefined") {
            let planInfo = (await planApi.get_plan_info(planId)).data;

            if (planInfo.creator === this.login_user_id) {
                this.title = planInfo.title;
                localStorage.setItem('edit_post_content', planInfo.title)
                this.plan_id = planInfo.id;
                this.planType = planInfo.plan_type;
                this.dateValue = planInfo.open_time;
                this.startDate = planInfo.open_time;
                this.endDate = planInfo.end_time;
                this.content = planInfo.content;
                this.summary = planInfo.summary;

                let args = {
                'planid': planInfo.id,
                'uid': planInfo.creator,
                    'sdate': this.startDate,
                    'edate': this.endDate,
                    'ptype': this.planType,
                }
                let d = await planApi.get_my_todos_by_date(args);
                let curr_details = d.data.filter(x => x.plan_id === planInfo.id);
                let other_details = d.data.filter(x => x.plan_id !== planInfo.id);
                this.details_info = [].concat(curr_details.sort((a, b) => a.id - b.id))
                    .concat(other_details.sort(function (a, b) {
                        if (a.plan_id === b.plan_id) return a.id - b.id;
                        else return a.plan_id - b.plan_id;
                    }));
                this.lists = [];
                this.details_info.forEach((item) => {
                    let currData = {
                        id: item.id,
                        plan_id: item.plan_id,
                        content: item.details,
                        rDate: item.start_time,
                        eDate: item.end_time,
                        isImportant: item.isImportant,
                        isEmergency: item.isEmergency,
                        isDelete: item.isDelete,
                    };
                    if (item.plan_id !== planId && !item.isDelete) this.otherList.push(currData)
                    else if (item.isDelete) this.recycleList.push(currData);
                    else this.lists.push(currData);
                })
            } else {
                this.change_warning_bar_style_class('alert');
                await this.$router.go(-1);
            }
        } else {
            this.change_warning_bar_style_class('alert');
            await this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.top-bar {
    position: relative;
    padding: 10px 20px;
    overflow: hidden;
    background-color: #fff;
}

[class^="icon-"] {
    background-image: url(/static/img/plan.png?v=6);
    background-image: -webkit-image-set(url(/static/img/plan.png?v=6) 1x, url(/static/img/plan@2x.png?v=6) 2x);
    background-image: image-set(url(/static/img/plan.png?v=6) 1x, url(/static/img/plan@2x.png?v=6) 2x);
    vertical-align: middle;
    display: inline-block;
    background-repeat: no-repeat;
}

.new-main {
    background-color: #fff;
    padding-left: 24px;
    overflow: auto;
    z-index: -1 \0;
}

.new-main table {
    border-collapse: separate;
}

.new-main table td.odd {
    min-width: 70px;
}

.must-fill {
    font-style: normal;
    color: #f00;
}

.new-main table td.even {
    padding-left: 4px;
}

.new-main table td input[type='text'] {
    width: 380px;
    height: 30px;
    padding-left: 8px;
    border: 1px solid #d7d8d9;
}

.new-main table td .other-plan {
    margin-left: 13px;
}

.new-main table td .title-tip {
    position: absolute;
}

.remark_r {
    color: #F00;
}

.new-main table .v-top {
    vertical-align: top;
    text-align: right;
}

.new-main table td .mar-top16 {
    margin-top: 16px;
}

.new-main table .v-top span {
    display: inline-block;
}

.new-main table td .plan-content-wrap {
    border: 1px solid transparent;
    margin-top: 5px;
}

.new-main table td .plan-content {
    position: relative;
    width: 820px;
    padding: 9px;
    background-color: #f8f8f8;
    transition: border-color .3s;
    border: 1px solid transparent;
    border-radius: 12px;
}

.new-main table td .plan-content input[type='text'] {
    width: 648px;
}

.new-main table td .content-tip {
    line-height: 24px;
    height: 16px;
}

.new-main table td .recovery-tip {
    height: 16px;
    margin: 4px 0 25px 20px;
    font-size: 16px;
}

.new-main table td .plan-content .plan-detail-box {
    padding: 10px 0;
}

.new-main table td .plan-content .plan-detail {
    position: relative;
    overflow: hidden;
}

.new-main table td .plan-content textarea {
    resize: none;
    width: 596px;
    min-height: 60px;
    padding-right: 20px;
    border-radius: 0;
    border: 1px solid #d7d8d9;
    margin-bottom: 2px;
    overflow: hidden;
}

.icon-remove {
    background-position: -208px -250px;
    height: 16px;
    width: 16px;
}

.icon-delete {
    background-position: -208px -250px;
    height: 16px;
    width: 16px;
}

.fa-recovery {
    height: 16px;
    width: 16px;
    color: #d3d3d3;
}

.icon-remove:hover {
    background-position: -208px -232px;
}

.fa-recovery:hover {
    color: #e7041c;
}

.true-remove:hover {
    background-position: -208px -232px;
}

.new-main table td .remove {
    font-size: 18px;
    position: relative;
    text-shadow: none;
    top: 1px;
    margin-left: 12px;
    margin-right: 16px;
    color: #a7bdcd;
    font-style: normal;
    font-family: "Font Awesome 5 Pro";
    font-weight: 900;
}

.new-main table td .sec-remove {
    position: absolute;
    top: 2px;
    left: 735px;
    background-color: transparent;
    margin: 5px 0 0 0;
}

.new-main table td .true-remove {
    position: absolute;
    left: 760px;
    background-color: transparent;
    margin: 5px 0 0 0;
}

.new-main table td .fa-recovery {
    position: absolute;
    top: 2px;
    left: 735px;
    background-color: transparent;
    margin-top: 5px;
}

.new-main table td .plan-content .add-detail {
    cursor: pointer;
    margin-left: 20px;
    margin-top: 15px;
}

.new-main table td .plan-content i {
    cursor: pointer;
}

.new-main table td .plan-content .add-detail i {
    vertical-align: 0px;
    margin-right: 4px;
}

.text-blue {
    color: #2299ee;
}

.text-gray {
    color: #ccc;
}

.new-main table td .plan-content .add-detail span {
    margin-right: 10px;
}

.new-main table td .add-category {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #f8f8f8;
    color: #2299ee;
    cursor: pointer;
    width: 700px;
}

.icon-add-category {
    font-style: normal;
    background-position: -32px -32px;
    width: 18px;
    height: 18px;
}

.new-main table td .add-category i {
    vertical-align: middle \0;
    margin-right: 8px;
}

.new-main table .v-top {
    vertical-align: top;
    text-align: right;
}

.padding-top-a8 {
    padding-top: 8px;
}

.new-main table td .plan-conclusion {
    width: 689px;
    resize: none;
    border-radius: initial;
}

.btn-group {
    position: relative;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    vertical-align: middle;
    white-space: nowrap;
    *margin-left: .3em;
}

.new-main table td .btn-group button {
    height: 30px;
    margin-right: 10px;
    border-style: none;
    font-size: 12px;
    border-radius: 3px
}

.new-main table td .btn-group button.release {
    width: 120px;
    background-color: #2299ee;
    color: #fff;
}

.new-main table td .btn-group button.cancel {
    width: 90px;
    background-color: #fff;
    border: 1px solid #d7d8d9;
    color: #000;
}

#week-plan, #month-plan, #quarter-plan {
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
}

* {
    margin: 0;
    padding: 0;
    list-style: none;

}


.navBar input {
    width: 215px;
    height: 38px;
    display: inline-block;
}


.show1 p:nth-child(1) {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #f5f5f5;
}

.show1 p:nth-child(2) {
    box-sizing: border-box;
}

</style>
<style>

.detailDate .el-input__icon {
    height: 28px;
    line-height: 28px;
}

.detailDate .el-input__inner {
    height: 28px;
    line-height: 28px;
    width: 105px;
    font-size: 11px;
}

.plan-detail .el-input--suffix .el-input__inner {
    padding-right: 0px !important;
}

.detailDate.el-input {
    height: 28px;
    line-height: 28px;
}

.el-date-editor--daterange.el-input__inner {
    width: 220px !important;
}

.el-date-editor .el-range-input {
    width: 40% !important;
    font-size: 11px !important;
}

.el-date-editor .el-range-separator {
    width: 11% !important;
}
</style>